import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tabs } from 'projects/access-control/src/app/Domain/Entities/tabs.interface';
import { IFields } from 'projects/access-control/src/app/Domain/Entities/fields.interface';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
	selector: 'app-modal-design-form',
	templateUrl: './modal-design-form.component.html',
	styleUrls: ['./modal-design-form.component.scss'],
})
export class ModalDesignFormComponent implements OnInit {
	title = 'Design Form for ';
	tabs: Tabs[] = [
		{ label: 'General', value: '1' },
		{ label: 'Layout', value: '2' },
	];
	viewSelect: string = '';
	text: string = '';
	fields: IFields[] = [
		{
			name: 'Fields1',
			placeholder: 'fields1',
			required: true,
			type: 'select',
			id: 'select',
			label: 'Field1',
		},
		{
			name: 'Fields2',
			placeholder: 'fields2',
			required: false,
			type: 'text',
			id: 'text',
			label: 'Field2',
		},
		{
			name: 'Fields3',
			placeholder: 'fields3',
			required: true,
			type: 'radio',
			id: 'text',
			label: 'Field3',
		},
	] as IFields[];
	fields2: IFields[] = [
		{
			name: 'Fields11',
			placeholder: 'fields11',
			required: true,
			type: 'select',
			id: 'select1',
			label: 'Field1',
		},
		{
			name: 'Fields22',
			placeholder: 'fields22',
			required: false,
			type: 'text',
			id: 'text2',
			label: 'Field22',
		},
		{
			name: 'Fields33',
			placeholder: 'fields3',
			required: true,
			type: 'radio',
			id: 'text3',
			label: 'Field33',
		},
	] as IFields[];
	rows: IFields[][] = [this.fields, this.fields2];
	constructor(
		public dialogRef: MatDialogRef<ModalDesignFormComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {}

	onNoClick(): void {
		this.dialogRef.close();
	}
	save(): void {}
	tabSelect(event: any) {
		this.viewSelect = event;
	}
	addRowOneColum() {
		this.rows = [...this.rows, [{}]] as IFields[][];
	}
	addRowTwoColum() {
		this.rows = [...this.rows, [{}, {}]] as IFields[][];
	}
	addRowTreeColum() {
		this.rows = [...this.rows, [{}, {}, {}]] as IFields[][];
	}

	remove(index: number) {
		const field = this.rows[index];
		this.rows.splice(index, 1);
	}

	top(index: number, indexTop: number) {
		if (indexTop !== -1) {
			const element = this.rows[index];
			const elementTop = this.rows[indexTop];
			this.rows.splice(indexTop, 1, element);
			this.rows.splice(index, 1, elementTop);
		}
	}

	bottom(index: number, indexBottom: number) {
		if (indexBottom <= this.rows.length - 1) {
			const element = this.rows[index];
			const elementBottom = this.rows[indexBottom];
			this.rows.splice(indexBottom, 1, element);
			this.rows.splice(index, 1, elementBottom);
		}
	}

	drop(event: CdkDragDrop<IFields[]>) {
		if (event.previousContainer.id === event.container.id) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(
				event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex
			);
		}
	}

	dropCards(event: CdkDragDrop<IFields[]>) {
		if (event.previousContainer.id === event.container.id) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(
				event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex
			);
		}
	}
}
